import * as z from "zod";

export const StorefrontStoreHomeSchema = z.object({
  subdomain: z.string().nullable(),
  url: z.string().nullable(),
});

/** Body of the storefront's `/api/store-home` route. */
export const StorefrontStoreHomeUrlSchema = StorefrontStoreHomeSchema.pick({ url: true });

export type StorefrontStoreHomeUrl = z.infer<typeof StorefrontStoreHomeUrlSchema>;
